import { CustomTableHeader } from '../../../../components/CustomTable';

export const valoresExibidosOffCanvasMedsus: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  obm: 'Código OBM',
  protocolosAtivos: 'Protocolos Ativos',
  produtoDAF: 'Produto Farmacêutico',
};

export const offCanvasMedsus: Record<string, string> = {
  id: 'ID da Programação',
  produtoFarmaceutico: 'Produto Farmacêutico',
  obm: 'OBM',
  separadorProduto: '',
  listaPacienteObrigatoria: 'Lista de Pacientes Obrigatória?',
  modeloLista: 'Lista Modelo',
  upload: 'Lista de Pacientes',
  download: 'Lista Analisada',
  ses_pacientes: 'Pacientes Informados',
  pacientesValidados: 'Pacientes Validados',
  separadorPacientes: '',
  ses_consumo_pacientes: 'Consumo Estimado dos Pacientes Aprovados',
  ses_estoque: 'Estoque SES',
  ses_necessidade: 'Solicitação SES',
  separadorDemanda: '',
  total_aprovado: 'Total Aprovado MS',
  criterioAprovacao: 'Critério de Aprovação',
  total_enviado: 'Total Enviado',
  total_entregue: 'Total Entregue',
  separadorRegra: '',
  regraValidacao: 'Regra de validação da lista de pacientes',
};

export type MedsusTableRow = {
  id: string | number;
  nome: string;
  medicamento: string;
  [key: string]: any;
};

export type DiretrizMedsusTableRow = {
  id: string | number;
  status: string;
  respAquisicao: string;
  respFinanciamento: string;
  tipo: string;
  componenteAF: string;
  nome: string;
  [key: string]: any;
};

export const headersMedsus: CustomTableHeader<MedsusTableRow>[] = [
  { text: '', width: 1, key: '', renderable: false },
  { text: 'ID', width: 6, key: 'id' },
  { text: 'Diretriz Clínica', width: 25, key: 'nome' },
  { text: 'Medicamentos OBM', width: 70, key: 'medicamento' },
];

export type MedsusPublicTableRow = {
  nome: string;
  localizacao: string;
  [key: string]: any;
};

export const headersDiretrizMedsus: CustomTableHeader<DiretrizMedsusTableRow>[] =
  [
    { text: 'ID', width: 2, key: 'id' },
    { text: 'Status', width: 10, key: 'status' },
    { text: 'Resp. Aquisição', width: 12, key: 'respAquisicao' },
    {
      text: 'Resp. Financiamento',
      width: 12,
      key: 'respFinanciamento',
    },
    { text: 'Tipo', width: 8, key: 'tipo' },
    { text: 'Componente AF', width: 10, key: 'componenteAF' },
    { text: 'Nome da Diretriz', width: 45, key: 'nome' },
  ];

export const headersCriteriosMedsus = [
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 12, key: 'status' },
  { text: 'Tipo', width: 15, key: 'tipo' },
  { text: 'Título', width: 23, key: 'titulo' },
  { text: 'Descrição', width: 48, key: 'descricao' },
];

export const headersDocumentosMedsus = [
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 10, key: 'status' },
  { text: 'Tipo', width: 15, key: 'tipo' },
  { text: 'Subtipo', width: 20, key: 'subtipo' },
  { text: 'Finalidade', width: 53, key: 'finalidade' },
];

export const headersCIDMedsus = [
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 10, key: 'status' },
  { text: 'CID-10', width: 10, key: 'cid' },
  { text: 'Descrição', width: 78, key: 'descricao' },
];

export const fieldObjectMedsus = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];

export type DiretrizVmpMedsusTableRow = {
  id: string | number;
  vmpObm: string;
  vmpNome: string;
  [key: string]: any;
};

export const headersDiretrizVmpMedsus: CustomTableHeader<DiretrizVmpMedsusTableRow>[] =
  [
    { text: 'ID', width: 2, key: 'id' },
    { text: 'VMP OBM', width: 10, key: 'vmpObm' },
    { text: 'Medicamento', width: 50, key: 'vmpNome' },
  ];
